import { useTranslation } from "react-i18next";
import { StayPlansSection } from "./StayPlansSection";

interface OwnerStayPlansSectionProps {
  clinicId: string;
  ownerId: string;
  pets: Array<{ id: string; name: string }>;
  hasDaycare: boolean;
  hasHotel: boolean;
  canContract: boolean;
}

export function OwnerStayPlansSection({
  clinicId,
  ownerId,
  pets,
  hasDaycare,
  hasHotel,
  canContract,
}: OwnerStayPlansSectionProps) {
  const { t } = useTranslation("patients");

  return (
    <section className="space-y-5">
      <h3 className="text-lg font-semibold">{t("packagesTab.ownerPlansTitle")}</h3>
      {pets.length === 0 ? (
        <div className="rounded-lg border border-border bg-muted/20 px-4 py-5 text-sm text-muted-foreground">
          {t("packagesTab.ownerPlansEmpty")}
        </div>
      ) : (
        pets.map((pet) => (
          <div key={pet.id} className="space-y-3">
            <h4 className="text-sm font-semibold text-foreground">{pet.name}</h4>
            <StayPlansSection
              clinicId={clinicId}
              ownerId={ownerId}
              petId={pet.id}
              petName={pet.name}
              hasDaycare={hasDaycare}
              hasHotel={hasHotel}
              canContract={canContract}
            />
          </div>
        ))
      )}
    </section>
  );
}
